export type DashboardStat = {
  title: string;
  value: string;
  trend: string;
  accent: string;
};

export type DashboardScope = {
  title: string;
  description: string;
  total: number;
  pending: number;
  inProgress: number;
  path: string;
};

export type DashboardPriority = {
  title: string;
  owner: string;
  count: number;
  note: string;
  status: "critical" | "attention" | "stable";
};

export type DashboardTimelineItem = {
  title: string;
  description: string;
  date: string;
  day: string;
};

export type DashboardHero = {
  title: string;
  description: string;
  highlightedCounts: string[];
};

export const dashboardStats: DashboardStat[] = [
  {
    title: "Total Complaints",
    value: "2,145",
    trend: "+7% from last month",
    accent: "from-blue-500 to-blue-700",
  },
  {
    title: "Feedback Submitted",
    value: "312",
    trend: "+18% from last month",
    accent: "from-amber-400 to-amber-600",
  },
  {
    title: "Appeals Filed",
    value: "97",
    trend: "+4% from last month",
    accent: "from-emerald-400 to-emerald-600",
  },
  {
    title: "Active Users",
    value: "1,024",
    trend: "+2% from last month",
    accent: "from-cyan-500 to-cyan-700",
  },
];

export const dashboardScopeCards: DashboardScope[] = [
  {
    title: "Service Complaints",
    description:
      "Customer and administrative complaints requiring urgent attention.",
    total: 367,
    pending: 94,
    inProgress: 51,
    path: "/service-complaints",
  },
  {
    title: "Service Appeals",
    description:
      "Appeals regarding complaint decisions and administrative actions.",
    total: 163,
    pending: 29,
    inProgress: 19,
    path: "/service-appeals",
  },
  {
    title: "Prosecutor Complaints",
    description: "Complaints against prosecutorial conduct and case handling.",
    total: 104,
    pending: 21,
    inProgress: 17,
    path: "/prosecutor-complaints",
  },
  {
    title: "Prosecutor Appeals",
    description: "Appeals of prosecutorial decisions and outcomes.",
    total: 72,
    pending: 15,
    inProgress: 13,
    path: "/prosecutor-appeals",
  },
  {
    title: "Feedback & Reviews",
    description: "Feedback and reviews from system users.",
    total: 97,
    pending: 14,
    inProgress: 9,
    path: "/feedback",
  },
];

export const dashboardPriorities: DashboardPriority[] = [
  {
    title: "Urgent Complaints",
    owner: "COMPLAINT DESK",
    status: "critical",
    count: 21,
    note: "Complaints requiring immediate review and assignment.",
  },
  {
    title: "Unaddressed Feedback",
    owner: "FEEDBACK TEAM",
    status: "attention",
    count: 14,
    note: "Feedback submissions pending response for over 3 days.",
  },
  {
    title: "Appeals Awaiting Review",
    owner: "APPEAL OFFICER",
    status: "attention",
    count: 8,
    note: "Appeals filed and awaiting initial review.",
  },
  {
    title: "User Verifications",
    owner: "ADMIN",
    status: "stable",
    count: 37,
    note: "New user accounts pending verification.",
  },
];

export const dashboardTimeline: DashboardTimelineItem[] = [
  {
    title: "Complaint Submission Deadline",
    description: "Last day to submit new complaints for this quarter.",
    date: "March 27, 2026",
    day: "27",
  },
  {
    title: "Feedback Review Meeting",
    description: "Team meeting to review and address all pending feedback.",
    date: "March 28, 2026",
    day: "28",
  },
  {
    title: "Appeal Hearing Session",
    description: "Scheduled hearing for unresolved appeals.",
    date: "March 29, 2026",
    day: "29",
  },
  {
    title: "User Onboarding Webinar",
    description:
      "Webinar for new users on complaint system usage and best practices.",
    date: "March 31, 2026",
    day: "31",
  },
];

export const dashboardHero: DashboardHero = {
  title: "Complaint Management Dashboard",
  description:
    "Monitor complaints, feedback, appeals, and user activity. Track key metrics and ensure timely, transparent handling of all submissions.",
  highlightedCounts: [
    "2,145 Total Complaints",
    "312 Feedback Submitted",
    "97 Appeals Filed",
  ],
};
